import { SALUTATION_MR, SALUTATION_MRS } from 'views/consts/customer'

export const BILLING: string = 'billing'
export const SHIPPING: string = 'shipping'
export const PUP: string = 'pickupStation'

export const BILLING_FORM_ID: string = 'billing-address-form'

export const ADDRESS_SALUTATION = {
  [SALUTATION_MR]: 'mr',
  [SALUTATION_MRS]: 'mrs'
}
